
import {Component, Mixins, Watch} from "vue-property-decorator";

import PazOrderDeliveryDialog from "@pazion/pazion-catalog/src/components/dialog/PazOrderDeliveryDialog.vue";
import PazMultipleShipmentDialog from "@pazion/pazion-catalog/src/components/dialog/PazMultipleShipmentDialog.vue";
import PazDocumentsDialog from "@pazion/pazion-catalog/src/components/dialog/PazDocumentsDialog.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import PazToast from "@pazion/pazion-core/src/components/utils/PazToast.vue";
import EntityLogDialog from "@pazion/pazion-core/src/components/utils/EntityLogDialog.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazMenuDatePicker from "@pazion/pazion-core/src/components/input/PazMenuDatepicker.vue";
import PazDateField from "@pazion/pazion-core/src/components/utils/PazDateField.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";

import {
  getFulfilmentTable,
  getFulfilment,
  updateFullfilment, combineFilesAndDownload,
} from "../../services/catalog-service";
import {DataTableHeader} from "vuetify";
import {ITablePaginationOptions} from "../../models/base";
import {IFulfilment, IFulfilmentPaginateModel} from "../../models/fulfilment";
import FullfilmentAttributesMixin from "./mixins/fulfilmentAttributes.mixin";
import EntityLogMixin from "@pazion/pazion-core/src/mixins/EntityLog.mixin";
import {
  deleteFulfilment,
  getFulfilmentStatuses,
} from "@pazion/pazion-catalog/src/services/catalog-service";
import {getFileContent} from "../../services/base-service";

import {b64toBlob} from "@pazion/pazion-core/src/helpers/Helper";

import onScan from "onscan.js";
import fileSaver from "file-saver";

import PermissionService from "@pazion/pazion-core/src/services/permission-service";

@Component({
  components: {
    EntityLogDialog,
    PazRefreshButton,
    PazTooltipButton,
    PazOrderDeliveryDialog,
    PazToast,
    PazConfirmation,
    PazDateField,
    PazMenuDatePicker,
    PazDocumentsDialog,
    PazMultipleShipmentDialog,
  },
})
export default class Fulfilmentlisting extends Mixins(
    FullfilmentAttributesMixin,
    EntityLogMixin,
    PermissionService
) {
  $refs!: {
    confirm: PazConfirmation;
    toast: PazToast;
  };

  public showShipmentFilesModal: boolean = false;

  private _timerId = null;
  public loading: boolean = false;
  public search: string = "";
  defaultEntityType = "fulfilment";

  public items = [] as IFulfilmentPaginateModel[];
  public footerProps = {
    itemsPerPageOptions: [50, 100, 200, -1],
  };

  public defaultQueryPaginationsOpt = {
    pagination: 1,
    perPage: 50,
    page: 1,
    expand: "order,customer,product,transport,attributeValue,batchFulfilment,file,carrier,carrierService",
  };

  public deliverAtDate: string = "";

  public queryPaginationOpt = {...this.defaultQueryPaginationsOpt};
  public selectedShipmentStatus: string | null = null;
  public selectedTransporter: string | null = null;

  public paginationOptions: ITablePaginationOptions = {itemsPerPage: 100};
  public totalItems = 1;

  public showOrderDeliveryDialog: boolean = false;

  public selectedFulfilment: IFulfilment | null = null;
  public batchFulfilment: number | null = null;

  public FulfilmentStatuses: { fulfilmentStatuses: any } = {
    fulfilmentStatuses: null,
  };

  public dateEqualOperator = "like";
  public operatorsArray = [
    {
      name: "lt",
      id: "<",
    },
    {
      name: "lte",
      id: "<=",
    },
    {
      name: "like",
      id: "=",
    },
    {
      name: "gt",
      id: ">",
    },
    {
      name: "gte",
      id: ">=",
    },
  ];

  private fullfilmentTableHeaders: DataTableHeader[] = [
    {
      text: "id",
      align: "start",
      sortable: true,
      value: "id",
    },
    {
      text: "Order",
      align: "start",
      sortable: false,
      value: "order",
    },
    {
      text: "Batch",
      align: "start",
      sortable: false,
      value: "batchFulfilment",
    },
    {
      text: "Reference",
      align: "start",
      sortable: true,
      value: "reference",
    },
    {
      text: "Tenant",
      align: "start",
      sortable: true,
      value: "tenant",
    },
    {
      text: "Contact",
      align: "start",
      sortable: true,
      value: "order.contact",
    },
    {
      text: "Status",
      align: "start",
      sortable: true,
      value: "status",
    },
    {
      text: "Transport",
      align: "start",
      sortable: true,
      value: "transporter",
    },
    {
      text: "Track-trace",
      align: "start",
      sortable: false,
      value: "transport[0].trackntrace",
    },
    {
      text: "Created at",
      align: "start",
      sortable: false,
      value: "createdAt",
    },
    {
      text: "Deliver at",
      align: "start",
      sortable: false,
      value: "deliverAt",
    },
    {
      text: "Actions",
      align: "end",
      sortable: false,
      value: "actions",
    },
  ];


  selectedItems: IFulfilment[] = [];


  isDownloading: boolean = false;


  visibleFiles(files:object[]):[]{
    return files.filter( item => !item.isHidden);
  }

  async combineSelectedFiles() {
    let list: number[] = [];
    const uniqueFileHashes = new Set<string>();
    for (const ful of this.selectedItems) {
      for (const file of ful.file) {
        if(file.isHidden){
          continue;
        }
        if (uniqueFileHashes.has(file.hash)) {
          continue;
        }
        uniqueFileHashes.add(file.hash);
        list.push(file.id);
      }
    }
    if (list.length < 2) {
      this.$refs.toast.show({
        message: `Selection needs at least 2 files to combine!`,
        color: 'warning',
      });
      return;
    }
    this.isDownloading = true;
    const rsp = await combineFilesAndDownload(list);
    if (rsp.content) {
      this.downloadFile(rsp.content, "combined_file.pdf");
    }
    this.isDownloading = false;
  }

  downloadFile(fileBlob: string, fileName: string) {
    const a = document.createElement("a");
    a.href = fileBlob;
    a.download = fileName;
    a.click();
  }


  get canDownloadCombinedFile(): boolean {
    return this.hasProfileFlag("fulfilmentManagement.downloadCombinedFile");
  }

  get canShowTableSelect() {
    return this.hasProfileFlag("fulfilmentManagement.batch");
  }

  linkToOrder(orderId: number | string) {
    this.$router.push({
      name: "orders",
      query: {orderId: orderId},
    });
  }

  async selectNextBatchItem(){

      let batchId = parseInt(this.selectedFulfilment?.batchFulfilment?.id);
      this.selectedFulfilment = null;
      let hasNextBatch = true;
      if(!hasNextBatch && batchId < 1){
        return;
      }
      this.selectedShipmentStatus = 'NEW';
      this.batchFulfilment = batchId;
      await this.fetchData(undefined, undefined, undefined);

      this.selectedFulfilment = this.getFulfilmentArray[0] ?? false;
      // this.
      // this.selectedFulfilment = //@todo select next one
      if(this.selectedFulfilment) {
        this.showOrderDeliveryDialog = true;
        return;
      }
    this.$refs.toast.show({
      message: `All fulfilments of batch are sent!`,
      color: 'success',
    });
    this.selectedShipmentStatus = null;
    this.batchFulfilment = null;
    await this.fetchData(undefined, undefined, undefined);
  }

  toogleDeliveryDialog(status: boolean, item: IFulfilment) {
    this.selectedFulfilment = item;
    this.showOrderDeliveryDialog = status;
  }

  async deleteShipments(item: IFulfilment) {
    const confirm = await this.$refs.confirmDeleteShipment.openConfirmDialog(
        "Delete",
        `Do you want to delete ${item.description}?`
    );
    if (confirm) {
      const rsp = await deleteFulfilment(item.id);
      if (rsp.success) {
        this.onSearch();
      }
    }
  }

  get fulfilmentStatusesList(): any[] {
    if (this.FulfilmentStatuses.fulfilmentStatuses) {
      return Object.keys(this.FulfilmentStatuses.fulfilmentStatuses);
    }
    return [];
  }

  /**
   * SECTION Filter
   * */

  handleSelectBatchFulfulment(batchFulfilment: number) {
    this.batchFulfilment = batchFulfilment;
    this.fetchData();
  }

  updateTransporter(value: string) {
    this.selectedTransporter = value;
    this.fetchData();
  }

  updateShipmentStatus(value: string) {
    this.selectedShipmentStatus = value;
    this.fetchData();
  }

  setDeliverDateFilter(selectedDate: string) {
    this.deliverAtDate = selectedDate;
    this.fetchData();
  }

  onChangeOperatorType() {
    if (this.deliverAtDate) {
      this.fetchData();
    }
  }

  handleClearFilters() {
    this.selectedShipmentStatus = null;
    this.deliverAtDate = "";
    this.dateEqualOperator = "like";
    this.search = "";
    this.batchFulfilment = null;
    this.selectedTransporter = "ALL";
    localStorage.setItem('shipmentFilters', JSON.stringify({}));
    this.fetchData();
  }

  get isAppliedFilters() {
    return !!Object.values(this.createFiltersObject()).length;
  }

  createFiltersObject() {
    let filter: {
      deliverAt?: {} | null;
      status?: string | null;
      operator?: string | null;
      description?: { like: string } | null;
      reference?: { like: string } | null;
      batchFulfilment?: number | null;
      transporter?: string | null;
    } = {};

    //NOTE: filter records by orderId from queryParams
    const fromOrder = this.$route.query && this.$route.query.order;

    if (fromOrder) return {order: fromOrder};

    // TODO: Adjust search
    if (this.search.length > 0) {
      filter.operator = "OR";
      filter.description = this.createSearchString(this.search);
      filter.reference = this.createSearchString(this.search);
    }

    if (this.deliverAtDate) {
      const currentOperator = this.dateEqualOperator
          ? this.dateEqualOperator
          : "like";
      filter.deliverAt = {[currentOperator]: this.deliverAtDate};
    }

    if (this.selectedShipmentStatus && this.selectedShipmentStatus !== "ALL") {
      filter.status = this.selectedShipmentStatus;
    }

    if (this.selectedTransporter && this.selectedTransporter !== "ALL") {
      filter.transporter = this.selectedTransporter;
    }

    if (this.batchFulfilment) {
      filter.batchFulfilment = this.batchFulfilment;
    }

    return filter;
  }

  /*
   * End Filter
   */

  /**
   * SECTION Paginations & search
   * */

  createSearchString(search: string) {
    return search.length > 0 ? {like: `%${this.search}%`} : null;
  }

  //NOTE: Create params from orderBy
  createOrderParams(): { [key: string]: "DESC" | "ASC" } | undefined {
    let orderBy: { [key: string]: "DESC" | "ASC" } | undefined = undefined;
    // @ts-ignore
    this.paginationOptions?.sortBy.length > 0 &&
    (orderBy = {
      [this.paginationOptions.sortBy[0]]: this.paginationOptions.sortDesc[0]
          ? "DESC"
          : "ASC",
    });
    return orderBy || undefined;
  }

  onSearch() {
    clearTimeout(this._timerId);
    this._timerId = setTimeout(async () => {
      const filters = this.createFiltersObject();
      const queryParams = Object.values(filters).length && {
        ...this.queryPaginationOpt,
        filter: JSON.stringify({
          ...filters,
        }),
      };
      const currentOrder = this.createOrderParams();
      await this.fetchData(queryParams, false, currentOrder);
    }, 800);
  }

  public transporterList: string[] = [];

  async fetchData(
      queryParams?:
          | {
        [key: string]: any | { [key: string]: string };
      }
          | {},
      isAllRecords?: boolean,
      order?: { [key: string]: "ASC" | "DESC" },
      clearQuery?: boolean
  ) {
    if (clearQuery) {
      this.$route.query &&
      this.$router.replace({query: null}).catch(() => {
      });
    }
    const currentFilter = {
      selectedShipmentStatus: this.selectedShipmentStatus,
      deliverAtDate: this.deliverAtDate,
      dateEqualOperator: this.dateEqualOperator,
      search: this.search,
      batchFulfilment: this.batchFulfilment,
      selectedTransporter: this.selectedTransporter
    }
    localStorage.setItem('shipmentFilters', JSON.stringify(currentFilter))

    let fullParams = queryParams ? queryParams : this.queryPaginationOpt;
    order && Object.assign(fullParams, {orderBy: JSON.stringify(order)});

    Object.assign(fullParams, {
      filter: JSON.stringify(this.createFiltersObject()),
    });

    try {
      this.loading = true;
      const response = await getFulfilmentTable({
        ...fullParams,
      });
      if (!response) return;

      this.items = response;

      this.totalItems = response._pagination._total;
      Object.assign(this.paginationOptions, {
        page: response._pagination._page,
        itemsPerPage: isAllRecords ? -1 : response._pagination._per_page,
      });
      if (!this.transporterList.length) {
        this.transporterList = [
          ...new Set(this.items._data.map((item) => item.transporter)),
        ] as string[];
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
    }
  }

  //NOTE: FROM Paginastion
  @Watch("paginationOptions")
  onUpdatePaginations(val, oldVal) {
    if (
        val.itemsPerPage !== oldVal.itemsPerPage ||
        val.page !== oldVal.page ||
        val.sortBy.length > 0
    ) {
      let orderBy;
      if (val.itemsPerPage > 0)
        this.queryPaginationOpt = {
          pagination: 1,
          perPage: val.itemsPerPage,
          page: val.page,
          expand:
              "order,customer,product,transport,attributeValue,batchFulfilment,file,fulfilmentOrderLine,orderLine,tenant",
        };
      else {
        this.queryPaginationOpt = {...this.defaultQueryPaginationsOpt};
        this.queryPaginationOpt.perPage = 200;
      }
      orderBy = this.createOrderParams();
      this.fetchData(this.queryPaginationOpt, val.itemsPerPage === -1, orderBy);
    }
  }

  /*
   * End paginations
   */

  get getTableHeaders() {
    const list = this.canShowBatch
        ? this.fullfilmentTableHeaders
        : this.fullfilmentTableHeaders.filter(
            (header) => header.text !== "Batch"
        );
    if (!this.canShowTenant) {
      return list.filter((header) => header.text !== "Tenant");
    }
    return list;
  }

  async toggleFilesDialog(item: IFulfilment) {
    this.selectedFulfilment = item;
    this.showShipmentFilesModal = !this.showShipmentFilesModal;
  }

  async retryFulfilment(item: IFulfilment) {
    const rsp = await updateFullfilment(item.id, {status: "NEW"});
    if (rsp.status == "NEW") {
      this.$refs.toast.show({
        message: `Shipment '${rsp.reference}' updated to NEW`,
      });
      await this.fetchData(this.queryPaginationOpt);
    }
  }


  async mounted() {
    // Enable scan events for the entire document
    onScan.attachTo(document);
    // Register event listener
    document.addEventListener("scan", this.handleScanBarcode);
    const prevFilters = localStorage.getItem('shipmentFilters');
    const getSavedFilters = prevFilters ? JSON.parse(prevFilters) : {};

    if (getSavedFilters.selectedShipmentStatus) {
      this.selectedShipmentStatus = getSavedFilters.selectedShipmentStatus;
    }
    if (getSavedFilters.deliverAtDate) {
      this.deliverAtDate = getSavedFilters.deliverAtDate;
    }
    if (getSavedFilters.dateEqualOperator) {
      this.dateEqualOperator = getSavedFilters.dateEqualOperator;
    }
    if (getSavedFilters.search) {
      this.search = getSavedFilters.search;
    }
    if (getSavedFilters.batchFulfilment) {
      this.batchFulfilment = getSavedFilters.batchFulfilment;
    }
    if (getSavedFilters.selectedTransporter) {
      this.selectedTransporter = getSavedFilters.selectedTransporter;
    }

    const statusesResp = await getFulfilmentStatuses();
    if (statusesResp && statusesResp.hasOwnProperty("fulfilmentStatuses"))
      this.FulfilmentStatuses = statusesResp;
  }

  isShowBatchIcon(id: string) {
    return !!this.filesList.find((item) => item.entityId === id);
  }

  async handleScanBarcode(sScancode: any) {
    const res = await getFulfilment({barcode: sScancode.detail.scanCode});
    if (res.length === 1) {
      const responce = await getFulfilmentTable({
        ...this.defaultQueryPaginationsOpt,
        perPage: this.totalItems,
      });
      const item = responce._data.find((item) => item.id === res[0].id);
      this.toogleDeliveryDialog(true, item);
    }
  }

  get getFulfilmentArray() {
    return (this.items && this.items._data) || [];
  }

  async updateFulfiltmentList(id: string) {
    await this.fetchData(undefined, undefined, undefined, false);
    this.selectedFulfilment = this.getFulfilmentArray.find(
        (item) => item.id === id
    );
  }

  get canShowBatch() {
    return this.hasProfileFlag("fulfilmentManagement.batch");
  }

  get canShowTenant() {
    return this.hasProfileFlag("tenantManagement.show");
  }

  get canShowShipmentFiles() {
    return this.hasProfileFlag("fulfilmentManagement.files");
  }

  async handleDownloadFile(hash: string) {
    if (!hash) return;
    const file = await getFileContent(hash);
    const fileURL = window.URL.createObjectURL(b64toBlob(file.fileData, "pdf"));
    fileSaver.saveAs(fileURL, file.filename);
  }

  beforeDestroy() {
    // Remove the 'scan' event listener
    document.removeEventListener("scan", this.handleScanBarcode);
    // Detach the event handler associated with the 'scan' event from the document
    onScan.detachFrom(document);
  }
}
